export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-950 rounded-xl overflow-hidden">
          <div className="flex-1 p-6 md:p-10 lg:p-12 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              移动观影，随时随地
            </h2>
            <p className="text-sm md:text-base text-background-300/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              91电影视频全面适配移动端浏览器，无需下载App即可在手机上畅享高清国产影视。
              自适应网络环境，智能调整画质，地铁上、午休时、旅途中，随时随地看好片。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/10 border border-background-50/20 cursor-pointer hover:bg-background-50/20 transition-colors whitespace-nowrap">
                <i className="ri-apple-line text-lg text-background-50"></i>
                <span className="text-xs text-background-50">iOS 端访问</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/10 border border-background-50/20 cursor-pointer hover:bg-background-50/20 transition-colors whitespace-nowrap">
                <i className="ri-android-line text-lg text-background-50"></i>
                <span className="text-xs text-background-50">Android 端访问</span>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[320px] lg:max-w-[380px] shrink-0 px-6 pb-6 lg:pb-0 lg:pr-10 lg:py-10">
            <div className="aspect-[9/16] rounded-lg overflow-hidden bg-background-800/50">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20cinematic%20movie%20interface%2C%20dark%20theme%20with%20warm%20golden%20accents%2C%20film%20poster%20thumbnails%2C%20clean%20UI%20design%2C%20elegant%20mobile%20app%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20minimal%20design&width=400&height=700&seq=app-mobile-cinema-01&orientation=portrait"
                alt="91电影视频移动端观影体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}